<template functional>
  <div class="error-page">
    <div class="error-page__container">
      <div class="code">
        404
      </div>
      <h2>Эта страница не найдена 😓</h2>
      <h3>Xорошая новость в том, что у нас много других отличных страниц!</h3>
      <p>В <a href="/reader">ридере</a> вы найдете десятки материалов про личные финансы и инвестиции.</p>
      <p>Либо вы можете вернуться к работе с MoneyKeeper с
        <router-link :to="{name:'home'}">главной страницы</router-link>
        .
      </p>
    </div>
  </div>

</template>

<script>
export default {
  name: "The404"
}
</script>

<style lang="scss" scoped>
.error-page {
  background: radial-gradient(58.11% 306.71% at 23.93% 10%, #1F313F 0%, #142736 38.81%);
  color: white;
  min-height: 100vh;
  text-align: center;
  position: relative;
  padding: 12.5vh 15px 60px;
  overflow: hidden;

  &:before {
    content: '';
    position: absolute;
    z-index: 1;
    top: 0;
    right: 8.8%;
    left: 0;
    margin: auto;
    background: url(/app/images/svg/lp/background-logo.svg);
    background-size: cover;
    width: 1488px;
    height: 1080px;
  }

  &__container {
    position: relative;
    z-index: 2;
  }

  .code {
    font-weight: 900;
    font-size: 360px;
    line-height: 422px;
    margin-bottom: 28px;
  }

  h2 {
    font-size: 36px;
    line-height: 42px;
    margin-bottom: 48px;
  }

  h3 {
    font-size: 24px;
    line-height: 28px;
    margin-bottom: 20px;
  }

  p {
    font-size: 18px;
    line-height: 21px;
    margin-bottom: 15px;
  }

  a {
    @apply text-red;
    transition: all .2s;

    &:hover {
      @apply text-red-hover;
      text-underline: none;
    }
  }

  @media (max-width: 1199px){
    &:before {
      height: 760px;
      width: 1080px;
    }
  }
  @media (max-width: 991px) {
    &:before {
      right: 0;
      left: -380px;
      width: 1160px;
      height: 780px;
    }
  }
  @media (max-width: 767px) {
    &:before {
      right: 0;
      left: -100px;
      width: 600px;
      height: 410px;
    }
    .code {
      font-size: 110px;
      line-height: 1.2;
    }
    h2 {
      font-size: 26px;
      margin-bottom: 28px;
    }
    h3 {
      font-size: 18px;
    }
    p {
      font-size: 14px;
    }
  }
}
</style>